import React from 'react';
import { Thread } from 'stream-chat-react';
import CustomMessage from '../CustomMessage';
import { IChatChannel } from '../../interfaces/IChatChannel';
import { UserRole } from '../../types/UserRole';
import CustomMessageInput from '../CustomMessageInput';
import useFollowOutput from '../../hooks/useFollowOutput';

interface IThreadWrapper {
    chatChannel: IChatChannel;
    userRole: UserRole;
}

const ThreadWrapper: React.FC<IThreadWrapper> = ({ chatChannel, userRole }) => {
    const [followOutput, onToggleInteraction] = useFollowOutput();

    return (
        <Thread
            additionalVirtualizedMessageListProps={{
                additionalVirtuosoProps: {
                    followOutput,
                },
                stickToBottomScrollBehavior: 'auto',
            }}
            Message={() => (
                <CustomMessage
                    chatChannel={chatChannel}
                    userRole={userRole}
                    onTogglePopover={onToggleInteraction}
                />
            )}
            fullWidth
            virtualized
            Input={CustomMessageInput}
        />
    );
};

export default ThreadWrapper;
